export default "__VITE_ASSET__c6c575eb__"